import { useSyncExternalStore } from "react";

/** Selected items for bulk edits. One selection at a time, cleared when the view changes. */
let selected = new Set<string>();
let anchor: string | null = null;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

export function useSelection(): Set<string> {
  return useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    () => selected,
  );
}

export function clearSelection() {
  if (!selected.size) return;
  selected = new Set();
  anchor = null;
  emit();
}

export function setSelection(ids: Iterable<string>) {
  selected = new Set(ids);
  emit();
}

/**
 * Click with the checkbox or Ctrl/Cmd toggles one item; Shift selects the range from the last one clicked,
 * in the order the view shows them.
 */
export function selectClick(id: string, order: string[], e: { shiftKey: boolean }) {
  const next = new Set(selected);
  if (e.shiftKey && anchor && order.includes(anchor)) {
    const [a, b] = [order.indexOf(anchor), order.indexOf(id)].sort((x, y) => x - y);
    for (const x of order.slice(a!, b! + 1)) next.add(x);
  } else if (next.has(id)) next.delete(id);
  else next.add(id);
  anchor = id;
  selected = next;
  emit();
}

export const isSelecting = () => selected.size > 0;
